<template lang="pug">
  #InvitationIndex.container-width
    h5.text-center.pt-2 邀請函列表
    b-card.rounded-0.m-3(
      bg-variant="light",
      v-for="(invitation,index) in invitations",
      :key="index"
      @click="$router.push({ name: 'sa-invitation-preview',params: {invitation: invitation}})"
    )
      h4.text-center {{ invitation.invite_title }}
      img.img-fluid.w-100.h-100.rounded(:src="invitation.invite_picture_url")
    infinite-loading(
      @infinite="infiniteHandler",
      :identifier="infiniteId",
      spinner="bubbles",
      ref="infiniteLoading"
    )
      .cursor-default.mt-3(slot="no-more") 無更多邀請函
      .cursor-default.mt-3(slot="no-results") 無更多邀請函
      .cursor-default.mt-3(slot="error") 發生錯誤，請重整重試一次

</template>

<script>
  import { mapState } from 'vuex';
  import InfiniteLoading from 'vue-infinite-loading';
  import $ from 'jquery';

  export default {
  name: 'InvitationIndex',
  components: {
    InfiniteLoading,
  },
  data() {
    return {
      id: null,
      infiniteId: +new Date(),
    };
  },
  mounted() {
    const vm = this;
    vm.initHandler();
  },
  methods: {
    initHandler() {
      const vm = this;
      vm.$swal.fire({
        title: '載入中，請稍候',
        allowOutsideClick: false,
        willOpen: () => {
          this.$swal.showLoading();
        }
      });
      vm.$store.commit('sa_invitation/resetInfiniteLoadingData');

      vm.$swal.close();
      vm.$store.commit('toggleLoading', false);
      vm.infiniteId += 1;
    },
    infiniteHandler($state) {
      const vm = this;

      vm.$store.dispatch('sa_invitation/getInvitationsHandler', {
        current_page: vm.pagination.current_page + 1,
        per_page: vm.pagination.per_page
      }).then(() => {
        if (vm.pagination.current_page !== vm.pagination.total_page) {
          $state.loaded();
        } else {
          $state.complete();
        }
      });
    },
    showInvitationHandler(reservation) {
      const vm = this;
      vm.$router.push({
        name: SA_MY_CUSTOMER_RESERVATION_EDIT,
        params: {
          id: reservation.reservation_id,
          userId: this.userId,
          editInfo: reservation
        }
      });
    }
  },
  computed: {
    ...mapState({
      invitations: (state) => state.sa_invitation.invitations,
      pagination: (state) => state.sa_invitation.pagination
    })
  }
};
</script>

<style>

</style>
